import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PayPalReturn() {
  const { t } = useApp();
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");
  const [booking, setBooking] = useState(null);
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const orderId = params.get("token"); // PayPal returns 'token' = order id
    const bookingId = params.get("booking_id");
    if (!orderId) { setState("failed"); return; }
    (async () => {
      try {
        const { data } = await api.post("/bookings/paypal-capture", { order_id: orderId });
        if (data.payment_status === "paid") { setState("paid"); setBooking(data.booking); }
        else setState("pending");
      } catch (e) { setState("failed"); }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="max-w-lg mx-auto px-6 py-24 text-center">
      {state === "loading" && <><Loader2 className="w-14 h-14 mx-auto text-[#005C7A] animate-spin mb-6" /><h1 className="font-display text-3xl font-bold mb-2">{t("payment.pending")}</h1></>}
      {state === "paid" && <>
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6"><CheckCircle2 className="w-10 h-10 text-green-600" /></div>
        <h1 className="font-display text-4xl font-bold mb-3">{t("payment.success")}</h1>
        <p className="text-muted-foreground mb-6">{t("payment.successMsg")}</p>
        {booking && <div className="bg-white border border-border rounded-2xl p-5 text-left mb-6" data-testid="paypal-booking-details">
          <div className="font-semibold">{booking.pool_title}</div>
          <div className="text-sm text-muted-foreground">{booking.hotel_name} · {booking.date} · {booking.guests} guest(s)</div>
          <div className="mt-2 font-bold">€{booking.amount?.toFixed(2)}</div>
          <div className="mt-1 text-xs text-muted-foreground">Paid with PayPal</div>
        </div>}
        <Link to="/guest"><Button className="rounded-full bg-[#005C7A]" data-testid="pp-go-to-bookings">{t("payment.mine")}</Button></Link>
      </>}
      {(state === "failed" || state === "pending") && <>
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6"><XCircle className="w-10 h-10 text-red-600" /></div>
        <h1 className="font-display text-3xl font-bold mb-3">{t("payment.failed")}</h1>
        <Link to="/search"><Button className="rounded-full bg-[#005C7A]">{t("payment.back")}</Button></Link>
      </>}
    </div>
  );
}
